import { Button, Modal } from 'react-bootstrap';
import { navTabs } from './edit-nav-key';

interface IProps {
    show: boolean,
    tabKey: string,
    onDiscard: () => void,
    onCancel: () => void
}

const DataChangedWarning = (props: IProps) => {
    const tabDescription = navTabs.find(x => x.key == props.tabKey).name;

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Data Change Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 10 }}>WARNING! You have pending changes in the {tabDescription} tab.</div>
                <div>Are you sure you want to discard these changes?</div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='warning' onClick={props.onDiscard}>Yes, Discard Changes</Button>
                <Button onClick={props.onCancel}>No, Return to Page</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DataChangedWarning;